import React from 'react'
import { Container, Row, Col} from 'react-bootstrap'
// import {
//   FaFacebookF,
//   FaTwitter,
//   FaLinkedInIn,
//   FaInstagram,
// } from 'react-icons/fa'
import doc_abt_img from '../../../assets/swati.webp'
import doc_abt_img1 from '../../../assets/gouravpanday.webp'
import doc_abt_img2 from '../../../assets/shubham.webp'
import linkedIn from '../../../assets/linkedIn.webp'
import instagram_img from '../../../assets/instagram.webp'
// import twitter from '../../../assets/twitter.webp'
import facebook from '../../../assets/facebook.webp'

const Doctorabout = () => {
  return (
    <>
      <div className="doctor_about my-5">
        <Container>
          <div className="Button_healthy">
            <span className="lets">Our Team</span>
          </div>
          <Row>
            <Col md={6}>
              <div className="doc_head my-4">
                <h2>
                  Meet Our Expert <span>Doctors</span>
                </h2>
              </div>
              <div className="doc_card">
                <Row>
                  <Col md={6}>
                    <div className="doc_card_left">
                      <p className="speciality">
                        Maxillofacial Aesthetic Surgeon
                      </p>
                      <h5>Dr. Sweta Mishra</h5>
                      <p className="abt_p">
                        Dr. Sweta mishra is a Maxillofacial Aesthetic Surgeon,
                        super-specialized in Facial Cosmetics, and Hair
                        Transplantation
                      </p>

                      <div className="doc_social">
                      <a href="https://www.facebook.com/sharvaclinique">
                          <img
                            src={facebook}
                            alt="social_media"
                            className=" media-icon mt-2"
                          />
                        </a>{' '}
                        <a href="" target="">
                          <img
                            src={linkedIn}
                            alt="social_media"
                            className=" media-icon mt-2"
                          />
                        </a>{' '}
                      
                        <a
                         href="https://www.instagram.com/sharvaclinique?igsh=Mm05NHFrcnU5ZTF5"
                          target=""
                        >
                          <img
                            src={instagram_img}
                            alt="social_media"
                            className="media-icon mt-2"
                          />
                        </a>{' '}
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="doc_abt_img">
                      <img src={doc_abt_img} alt="best cosmo aesthetic specialist in delhi" />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col md={6}>
              <div className="doc_card my-5">
                <Row>
                  <Col md={6}>
                    <div className="doc_card_left">
                      <p className="speciality">Chest and Allergy Specialist</p>
                      <h5>Dr. Gaurav Pandey</h5>
                      <p className="abt_p">
                        Dr Gaurav Pandey is working at a pvt. multispeciality
                        clinic as a senior MD pulmonologist.
                      </p>

                      <div className="doc_social">
                      <a href="https://www.facebook.com/sharvaclinique">
                          <img
                            src={facebook}
                            alt="social_media"
                            className=" media-icon mt-2"
                          />
                        </a>
                        <a href="https://www.linkedin.com/in/dr-gaurav-pandey-022506291/" target="">
                          <img
                            src={linkedIn}
                            alt="social_media"
                            className=" media-icon mt-2"
                          />
                        </a>{' '}
                        
                        <a
                          href="https://www.instagram.com/sharvaclinique?igsh=Mm05NHFrcnU5ZTF5"
                          target=""
                        >
                          <img
                            src={instagram_img}
                            alt="social_media"
                            className="media-icon mt-2"
                          />
                        </a>{' '}
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="doc_abt_img">
                      <img src={doc_abt_img1} alt="best chest and allergy specialist in delhi" />
                    </div>
                  </Col>
                </Row>
              </div>

              <div className="doc_card my-5">
                <Row>
                  <Col md={6}>
                    <div className="doc_card_left">
                      <p className="speciality">General and Aesthetic Physician</p>
                      <h5>Dr. Shubham Pandey</h5>
                      <p className="abt_p">
                        General physician with special interest in Aesthetic
                        medicine.
                      </p>

                      <div className="doc_social">
                      <a href="https://www.facebook.com/sharvaclinique">
                          <img
                            src={facebook}
                            alt="social_media"
                            className=" media-icon mt-2"
                          />
                        </a>
                        <a href="" target="">
                          <img
                            src={linkedIn}
                            alt="social_media"
                            className=" media-icon mt-2"
                          />
                        </a>{' '}
                        
                        <a
                          href="https://www.instagram.com/sharvaclinique?igsh=Mm05NHFrcnU5ZTF5"
                          target=""
                        >
                          <img
                            src={instagram_img}
                            alt="social_media"
                            className="media-icon mt-2"
                          />
                        </a>{' '}
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="doc_abt_img">
                      <img src={doc_abt_img2} alt="Expert Aesthetic Physician in delhi" />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default Doctorabout
